import { NgIf } from '@angular/common';
import { Directive, OnInit } from '@angular/core';
import { NgInject } from '@df/ng/ng-inject';
import { TradeStoreService } from './trade-store.service';
@Directive({
    selector: '[ifTradeStore]',
    standalone: true
})
export class IfTradeStoreDirective extends NgIf implements OnInit {
    @NgInject(TradeStoreService)
    private tradestoreService: TradeStoreService;
    ngOnInit() {
        this.ngIf = this.check();
    }
    protected check(): boolean {
        return this.tradestoreService.isTradeStore();
    }
}
